import { render, staticRenderFns } from "./Saleitems.vue?vue&type=template&id=0c552438&scoped=true"
import script from "./Saleitems.vue?vue&type=script&lang=js"
export * from "./Saleitems.vue?vue&type=script&lang=js"
import style0 from "./Saleitems.vue?vue&type=style&index=0&id=0c552438&prod&lang=css"
import style1 from "./Saleitems.vue?vue&type=style&index=1&id=0c552438&prod&scoped=true&lang=css"
import style2 from "./Saleitems.vue?vue&type=style&index=2&id=0c552438&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c552438",
  null
  
)

export default component.exports